import request from '@/utils/request'


// 查询取消原因列表
export function listCancelReason(query) {
  return request({
    url: '/order/cancel/reason/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询取消原因分页
export function pageCancelReason(query) {
  return request({
    url: '/order/cancel/reason/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询取消原因详细
export function getCancelReason(data) {
  return request({
    url: '/order/cancel/reason/detail',
    method: 'get',
    params: data
  })
}

// 新增取消原因
export function addCancelReason(data) {
  return request({
    url: '/order/cancel/reason/add',
    method: 'post',
    data: data
  })
}

// 修改取消原因
export function updateCancelReason(data) {
  return request({
    url: '/order/cancel/reason/edit',
    method: 'post',
    data: data
  })
}

// 删除取消原因
export function delCancelReason(data) {
  return request({
    url: '/order/cancel/reason/delete',
    method: 'post',
    data: data
  })
}
